import { useServices } from "contexts/ServiceContext";
import useConfigs from "hooks/useConfigs";
import React, { FC, useCallback } from "react";
import useTranslation from "translations/useTranslation";
import GroupedItem from "ui/components/SideMenu/GroupedItem";
import SideMenu from "ui/components/SideMenu/SideMenu";
import SingleItem from "ui/components/SideMenu/SingleItem";
import { Analytics } from "services/Analytics/Analytics";
import { EventEnum } from "enums/EventEnum";

const SideMenuContainer: FC<{}> = () => {
    const t = useTranslation();
    const configs = useConfigs();
    const services = useServices();
    const isLoyaltyCardsActive = configs.loyalty_cards_active;
    const isAchievementsEnabled = configs.enable_achievements;
    const goToMyProfile = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.CategoryMyProfile);
        services.NavigationService.Landing();
    }, [services.NavigationService]);

    const goToMyTiendeo = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.CategoryMyTiendeo);
        services.NavigationService.MyTiendeo();
    }, [services.NavigationService]);

    const goToHelp = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.CategoryHelp);
        services.NavigationService.Help();
    }, [services.NavigationService]);

    const goToFidelityCards = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.LoyaltyCards);
        services.NavigationService.LoyaltyCards();
    }, [services.NavigationService]);

    const goToMyMedals = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.MyMedals);
        services.NavigationService.MyMedals();
    }, [services.NavigationService]);

    const goToSavedPages = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.SavedPages);
        services.NavigationService.SavedPages();
    }, [services.NavigationService]);

    const goToNotifications = useCallback(() => {
        Analytics.Instance.sendEvent(EventEnum.Notifications);
        services.NavigationService.Notifications();
    }, [services.NavigationService]);

    return (
        <SideMenu>
            {configs.enable_login && (
                <SingleItem onClick={goToMyProfile}>
                    <a onClick={goToMyProfile}>{t("MY_PROFILE_TITLE")}</a>
                </SingleItem>
            )}
            {isLoyaltyCardsActive || isAchievementsEnabled ? (
                <GroupedItem textName={t("MY_TIENDEO")} onClick={goToMyTiendeo}>
                    {!configs.disable_favorites && (
                        <SingleItem>
                            <a onClick={goToNotifications}>{t("NOTIFICATIONS")}</a>
                        </SingleItem>
                    )}
                    <SingleItem>
                        <a onClick={goToSavedPages}>{t("YOUR_SAVED_OFFERS")}</a>
                    </SingleItem>
                    {configs.enable_login && (
                        <SingleItem>
                            <a onClick={goToFidelityCards}>{t("LOYALTY_CARDS")}</a>
                        </SingleItem>
                    )}
                    {isAchievementsEnabled && (
                        <SingleItem>
                            <a onClick={goToMyMedals}>{t("MY_MEDALS")}</a>
                        </SingleItem>
                    )}
                </GroupedItem>
            ) : (
                <GroupedItem textName={t("MY_TIENDEO")} onClick={goToMyTiendeo}>
                    <SingleItem>
                        <a onClick={goToNotifications}>{t("NOTIFICATIONS")}</a>
                    </SingleItem>
                    <SingleItem>
                        <a onClick={goToSavedPages}>{t("YOUR_SAVED_OFFERS")}</a>
                    </SingleItem>
                </GroupedItem>
            )}

            <SingleItem onClick={goToHelp}>
                <a onClick={goToHelp}>{t("HELP")}</a>
            </SingleItem>
        </SideMenu>
    );
};

export default SideMenuContainer;
